/**
 * useSpiceKindColors: the two SPICE session kind colours (fill and text)
 * for the signed-in tenant, read from tenants.config.spice.kind_colors
 * through the shared tenant-config query (useTenantConfig, the path the
 * rate-band and quiet-days seams use). While the config loads, or when
 * its read fails, both kinds read their defaults; the app shell has
 * usually warmed the cache already. Every surface that shows a kind
 * colour reads it here, so a colour the owner saves in Admin reaches the
 * grid, the legend, the toggle, the summary and My week the same way.
 */

import { useTenant } from '@/lib/auth';
import { useTenantConfig } from '@/hooks/useTenantConfig';
import { readSpiceKindColors, type SpiceKindColor } from '@/lib/spiceKindColor';
import type { SpiceSessionKind } from '@/lib/spiceVisitPlansApi';

export function useSpiceKindColors(): Record<SpiceSessionKind, SpiceKindColor> {
  const { tenantSlug } = useTenant();
  const { data } = useTenantConfig(tenantSlug);
  return readSpiceKindColors(data?.config);
}
